import type { SVGProps } from 'react';

const SvgRefreshBd = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox='0 0 24 24' fill='none' width='1em' height='1em' focusable='false' color='currentColor' {...props}>
    <path
      d='M20 14.8125C18.8561 18.4057 15.58 21 11.717 21C6.90275 21 3 16.9706 3 12C3 7.02944 6.90275 3 11.717 3C14.9436 3 17.7861 4.80989 19.2933 7.5M19.2933 7.5H15.3604M19.2933 7.5V3.5625'
      stroke='currentColor'
      strokeWidth={2}
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);
export default SvgRefreshBd;
